import { quickReplies, type Intent } from '../data/challans';
import styles from './QuickReplyChips.module.css';

interface QuickReplyChipsProps {
  onSelect: (intent: Intent, label: string) => void;
}

export function QuickReplyChips({ onSelect }: QuickReplyChipsProps) {
  return (
    <div className={styles.container}>
      <div className={styles.scroll}>
        {quickReplies.map((reply) => (
          <button
            key={reply.intent}
            type="button"
            className={styles.chip}
            data-testid={`quick-reply-${reply.intent}`}
            onClick={() => onSelect(reply.intent, reply.label)}
          >
            {reply.label}
          </button>
        ))}
      </div>
    </div>
  );
}
